"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var globalStyle_1 = require("./globalStyle");
Object.defineProperty(exports, "theme", { enumerable: true, get: function () { return __importDefault(globalStyle_1).default; } });
//# sourceMappingURL=index.js.map